// src/App.js
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/Home";
import ConnectWalletPage from "./pages/ConnectWallet";
import GlobalStyles from "./styles/GlobalStyles";
import { light } from "./styles/Themes";
import { ThemeProvider } from "styled-components";
import NftDetails from './pages/NftDetails';
import Login from "./pages/Login";
import Signup from "./pages/SignUp";
import PrivateRoute from "./components/PrivateRoute";
import CreateArt from "./pages/CreateArt";
import ConnectPage from "./pages/ConnectPage";
import DashboardPage from "./pages/Dashboard";
import { FundWalletForm, ManualFundForm, MintModal, TransferFundsForm, WithdrawFundsForm } from "./pages/FormPage";
import { AuthProvider } from "./context/AuthContext";
import ExplorePage from "./pages/ExplorePage";
import ManageUsers from "./pages/AdminPage";
import ManageArts from "./pages/ManageArts";
import CreatorPage from "./pages/CreatorPage";
import ClubsPage from "./pages/club";
import CreateClub from "./pages/Club/NewClub";
import ManageClubs from "./pages/Club/ManageClub";

function App() {
  return (
    <>
      <GlobalStyles />
      <ThemeProvider theme={light}>
        
        
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            <Route
              path="/"
              element={
                // <PrivateRoute>
                  <HomePage />
                // </PrivateRoute>
              }
            />
            <Route
              path="/explore"
              element={
                // <PrivateRoute>
                  <ExplorePage />
                // </PrivateRoute>
              }
            />
            <Route
              path="/connect-wallet"
              element={
                // <PrivateRoute>
                  <ConnectPage />
                // </PrivateRoute>
              }
            />
            <Route
              path="/create-art"
              element={
                // <PrivateRoute>
                  <CreateArt />
                // </PrivateRoute>
              }
            />
            <Route
              path="/clubs"
              element={
                // <PrivateRoute>
                  <ClubsPage />
                // </PrivateRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <DashboardPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/manual-connect"
              element={
                // <PrivateRoute>
                  <ConnectWalletPage />
                // </PrivateRoute>
              }
            />
            <Route
              path="/manage-users"
              element={
                <PrivateRoute>
                  <ManageUsers />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-arts"
              element={
                <PrivateRoute>
                  <ManageArts />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-clubs"
              element={
                <PrivateRoute>
                  <ManageClubs />
                </PrivateRoute>
              }
            />
            <Route
              path="/new-clubs"
              element={
                <PrivateRoute>
                  <CreateClub />
                </PrivateRoute>
              }
            />
            <Route
              path="/creator/:username"
              element={
                  <CreatorPage />
              }
            />
            <Route
              path="/fund"
              element={
                <PrivateRoute>
                  <FundWalletForm />
                 </PrivateRoute>
              }
            />
            <Route
              path="/transfer"
              element={
                <PrivateRoute>
                  <TransferFundsForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/withdraw"
              element={
                <PrivateRoute>
                  <WithdrawFundsForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/mint"
              element={
                <PrivateRoute>
                  <MintModal />
                </PrivateRoute>
              }
            />
            <Route
              path="/manual-mint"
              element={
                <PrivateRoute>
                  <ManualFundForm /> 
                 </PrivateRoute>
              }
            />
            <Route
              path="/nft/:id"
              element={
                // <PrivateRoute>
                  <NftDetails />
                // </PrivateRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
